import axios from "axios";

const API_BASE_URL = "/api/v1";

export const httpClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 10000,
});

